import React from 'react'
import ProtectionUninstall from '../protection-uninstall'

const ProtectionUninstallEn = () => {
    return <ProtectionUninstall languageCode="en" />
}

export default ProtectionUninstallEn
